<template>
     <div class="bg-green-cust rounded-lg p-5 font-poppins">
            <h1 class="text-lg font-bold text-slate-900 mb-5">DATA PASIEN</h1>
            <table width="100%">
                <tr>
                    <td>
                        NO RM
                    </td>
                    <td class="font-bold text-right"> 
                        {{pasien.FS_MR}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Nama Pasien
                    </td>
                    <td :class="(pasien.FS_NM_PASIEN.length >= 25)?longTextClass:smallTextClass">
                        {{pasien.FS_NM_PASIEN}}
                    </td>
                </tr>
                <tr>
                    <td>
                        No BPJS
                    </td>
                    <td class="font-bold text-right">
                        {{(pasien.peserta)?pasien.peserta.FS_KD_PESERTA:''}}
                    </td>
                </tr>
                <tr>
                    <td>
                        NIK
                    </td>
                    <td class="font-bold text-right">
                       {{pasien.FS_KD_IDENTITAS}}
                    </td>
                </tr>
                <tr>
                    <td>
                        TGL Lahir
                    </td>
                    <td class="font-bold text-right">
                       {{pasien.FD_TGL_LAHIR}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Alamat
                    </td>
                    <td class="font-bold text-right">
                        {{pasien.FS_ALM_PASIEN}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Jaminan
                    </td>
                    <td class="font-bold text-right">
                        {{(pasien.peserta)?(pasien.peserta.tipe_jaminan)?pasien.peserta.tipe_jaminan.FS_NM_TIPE_JAMINAN:'':'BAYAR SENDIRI'}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Periksa Terakhir
                    </td>
                    <td class="font-bold text-right">
                        {{pasien.FD_TGL_KUNJUNGAN_AKHIR}}
                    </td>
                </tr>
                <tr>
                    <td>
                        No HP
                    </td>
                    <td class="font-bold text-right">
                       {{pasien.FS_TELP_PASIEN}}
                    </td>
                </tr>
            </table>
            <Link :href="pasien.checkHistoryLink" class="bg-teal-600 hover:bg-teal-800 text-white rounded-lg h-12 p-5 ml-auto float-right flex items-center justify-center">RIWAYAT PENDAFTARAN</Link>
            <div class="clear-both"></div>
        </div>
</template>


<script>
    import { Link } from '@inertiajs/inertia-vue3'
    export default{
        data(){
           return {
                longTextClass: 'font-bold text-right text-xs',
                smallTextClass: 'font-bold text-right text-md'
           }
        },
        props: {
            pasien: Object,
        },
        components: {
            Link
        },
    }
</script>